<template>
  <v-row
    justify="start"
    class="mt-0 ms-n5"
    v-if="authStore.user && authStore.user.Academic_results"
  >
    <v-col cols="12" md="8">
      <v-card elevation="10">
        <v-card-title class="bg-indigo white--text d-flex align-center">
          <v-icon class="mr-2" color="white">mdi-chart-line</v-icon>
          ผลการเรียน ( Academic Result )
        </v-card-title>

        <v-card-text class="pa-4">
          <v-expansion-panels variant="accordion" multiple>
            <v-expansion-panel
              v-for="(yearData, yearKey) in authStore.user.Academic_results"
              :key="yearKey"
            >
              <v-expansion-panel-title
                class="text-subtitle-1 text-sm-h6 font-weight-medium"
              >
                <div class="d-flex align-center w-100">
                  <v-icon class="mr-3" color="primary"
                    >mdi-calendar-range</v-icon
                  >
                  <div class="flex-grow-1">
                    <div class="text-subtitle-1 font-weight-bold">
                      {{ yearKey }}
                    </div>
                    <div class="text-caption text-medium-emphasis opacity-75">
                      คลิกเพื่อดูรายละเอียด
                    </div>
                  </div>
                </div>
              </v-expansion-panel-title>

              <v-expansion-panel-text class="pa-0">
                <v-list class="text-left">
                  <v-list-item
                    v-for="(score, subjectKey) in yearData"
                    :key="subjectKey"
                  >
                    <v-list-item-title class="font-weight-medium">
                      {{ subjectKey }}
                    </v-list-item-title>

                    <template v-slot:append>
                      <div class="text-right">
                        <span
                          class="text-subtitle-1 font-weight-bold"
                          :style="{ color: getScoreColor(score) }"
                        >
                          {{ score }}
                        </span>
                        <div class="text-caption text-medium-emphasis">
                          คะแนน
                        </div>
                      </div>
                    </template>
                  </v-list-item>
                </v-list>
              </v-expansion-panel-text>
            </v-expansion-panel>
          </v-expansion-panels>
        </v-card-text>
      </v-card>
    </v-col>
  </v-row>
</template>

<script setup>
import { ref, onMounted, watch } from "vue";
import { useAuthStore } from "@/stores/auth";
// CHANGED: Removed duplicate import
import { getCurrentInstance } from "vue";

const { proxy } = getCurrentInstance();
const authStore = useAuthStore();
import axios from "axios";
const API_BASE_URL = process.env.VUE_APP_BACKEND_BASE_URL;
const searchOption = ref("studentNum");

// CHANGED: Added the getScoreColor function from your previous component
// We can use this to color the scores in the list.
const getScoreColor = (score) => {
  if (score >= 30) return "rgb(var(--v-theme-success))";
  if (score >= 20) return "rgb(var(--v-theme-warning))";
  if (score == "PASS") return "rgb(var(--v-theme-success))";
  return "rgb(var(--v-theme-error))";
};
</script>
